<template>
  <div>
    <div v-show="mediafile.sources.length > 0">
      <video-player :videoProp="mediafile" />
    </div>
    <show-processing type="video" :show="canSeeProcessing" :state="state"></show-processing>

    <transcript
      v-if="mediafile.captions && mediafile.captions.content"
      :transcript="mediafile.captions.content"
      :pdfUrl="mediafile.captions.download_pdf_path" sectionType="Markup">
    </transcript>
  </div>
</template>
<script>

import ShowProcessing from './show_processing.vue'
import Transcript from "../../tutorial_edit/components/sections/video_transcript.vue"
import VideoPlayer from "../../shared/components/video_player.vue"

import $ from 'jquery'

export default {
  components: {
    ShowProcessing,
    Transcript,
    VideoPlayer
  },
  props: {
    mediafile: {
      type: Object
    },
    canEdit: {
      type: Boolean
    }
  },
  computed: {
    state() {
      return this.mediafile.state
    },
    canSeeProcessing() {
      return this.canEdit && this.mediafile.sources.length < 1
    }
  }
}
</script>
